import React from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  PinterestShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { SHARE_STRING } from "../utils/constants";
import { FaShare, FaShareSquare } from "react-icons/fa";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
} from "@nextui-org/react";

function shareToPinterest(url, imageUrl) {
  const urlToShare = url;
  const description = "Check out this amazing content!"; // Customize the description
  const mediaUrl = imageUrl;

  window.PinUtils.pinOne({
    url: urlToShare,
    description: description,
    media: mediaUrl,
  });
}
const SocialShareButton = ({
  shareUrl,
  image,
  title,
  v2 = false,
  color = "bg-skin-50",
  icon = false,
}) => {
  return (
    <>
      <Dropdown>
        <DropdownTrigger>
          <span
            className={`${color} py-3.5 px-6 rounded-full cursor-pointer flex items-center gap-2 text-black text-center justify-center`}
          >
            Share {icon ? <FaShareSquare className="mr-2"></FaShareSquare> : ""}
          </span>
        </DropdownTrigger>
        <DropdownMenu aria-label="Static Actions">
          <DropdownItem key="new">
            <FacebookShareButton
              // url={"http://github.com"}
              url={shareUrl}
              title={title}
              className="w-full rounded"
            >
              <div className="flex items-center gap-2 hover:bg-slate-300 cursor-pointer w-full p-1 rounded">
                <FacebookIcon size={16} round />{" "}
                <span className="text-sm">Facebook</span>
              </div>
            </FacebookShareButton>
          </DropdownItem>
          <DropdownItem key="copy">
            {" "}
            <TwitterShareButton
              url={SHARE_STRING + shareUrl}
              className=" w-full rounded"
            >
              <div className="flex items-center gap-2 hover:bg-slate-300 cursor-pointer w-full p-1 rounded">
                <TwitterIcon size={16} round />{" "}
                <span className="text-sm">Twitter</span>
              </div>
            </TwitterShareButton>
          </DropdownItem>
          <DropdownItem key="edit">
            <WhatsappShareButton
              url={SHARE_STRING + shareUrl}
              className=" w-full rounded"
            >
              <div className="flex items-center gap-2 hover:bg-slate-300 cursor-pointer w-full p-1 rounded">
                <WhatsappIcon size={16} round />{" "}
                <span className="text-sm">Whatsapp</span>
              </div>
            </WhatsappShareButton>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default SocialShareButton;
